import { SendgridStatus } from "./constants";

// Special product names
export const PRODUCT_LEXI_SOCIAL = "Lexi Social";
export const PRODUCT_MELBOURNE_CUP_PROMO = "Melbourne Cup Promo";
export const PRODUCT_WEEKPASS = "Week Pass";
export const PRODUCT_LEXI_PREMIUM = "Lexi Pro";

// Owner, 2 Nov 2026: no VIP promos for now (no VIP slide, link, offer or pricing tier).
// Set to true to bring them back.
export const SHOW_VIP_PROMOS = false;

// DEPRECATED: These hardcoded Stripe URLs are being replaced by the new self-hosted checkout system
// They are kept for backward compatibility with existing components that haven't been migrated yet
// New implementations should use the CheckoutModal component instead
export const STRIPE_BASIC_PRODUCT_URL =
  "https://buy.stripe.com/28obIKgJc1sM2A0007";
export const STRIPE_PREMIUM_PRODUCT_URL = null;
export const STRIPE_VIP_PRODUCT_URL = null;

export const STRIPE_PROMO_PRODUCT_URL = "https://buy.stripe.com/6oU4gAetV1AibAt8Q76kg09";

export const STRIPE_STAGING_BASIC_PRODUCT_URL =
  "https://buy.stripe.com/test_8wM8xadlMahQ4mceUU";

export const STRIPE_DEV_BASIC_PRODUCT_URL =
  "https://buy.stripe.com/test_4gwcOscx5f7378A3cc";

// Day Pass product URLs
export const STRIPE_DAYPASS_DEV_URL =
  "https://buy.stripe.com/test_aFaaEZ6IA3spfROfBXdby04";
export const STRIPE_DAYPASS_STAGING_URL =
  "https://buy.stripe.com/test_5kQeVfb7sgMn5jCg9OdUY01";
export const STRIPE_DAYPASS_PROD_URL =
  "https://buy.stripe.com/6oU4gAetV1AibAt8Q76kg09";

// Week Pass product URLs
export const STRIPE_WEEKPASS_DEV_URL = "https://buy.stripe.com/test_00weVf6IA9QN49661ndby06";
export const STRIPE_WEEKPASS_STAGING_URL = "https://buy.stripe.com/test_bJe9AVfnIcw73bu2iYdUY02";
export const STRIPE_WEEKPASS_PROD_URL = "https://buy.stripe.com/6oU4gAetV1AibAt8Q76kg09";

// DEPRECATED: Use CheckoutModal component instead of direct Stripe URLs
export const getStripeUrlBasedOnEnvironment = () => {
  const hostname = window.location.hostname;
  if (
    hostname === "localhost" ||
    hostname.includes("127.0.0.1") ||
    hostname.includes("dev.")
  ) {
    return STRIPE_DEV_BASIC_PRODUCT_URL;
  } else if (hostname.includes("staging.")) {
    return STRIPE_STAGING_BASIC_PRODUCT_URL;
  } else {
    return STRIPE_BASIC_PRODUCT_URL;
  }
};

export const getDayPassStripeUrlBasedOnEnvironment = () => {
  const hostname = window.location.hostname;
  if (
    hostname === "localhost" ||
    hostname.includes("127.0.0.1") ||
    hostname.includes("dev.")
  ) {
    return STRIPE_DAYPASS_DEV_URL;
  } else if (hostname.includes("staging.")) {
    return STRIPE_DAYPASS_STAGING_URL;
  } else {
    return STRIPE_DAYPASS_PROD_URL;
  }
};

export const getStripeUrlForProduct = (productName, interval) => {
  if (productName === PRODUCT_MELBOURNE_CUP_PROMO) {
    return getDayPassStripeUrlBasedOnEnvironment();
  }
  
  if (interval === "month") {
    return getStripeUrlBasedOnEnvironment();
  }
  
  return getDayPassStripeUrlBasedOnEnvironment();
};

export const totalTips = 4;
export const minTips = 2;

export const sendgridValidStatuses = [SendgridStatus.PENDING_CONFIRMATION, SendgridStatus.ACTIVE, SendgridStatus.INACTIVE];
